/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {Button, Modal} from 'react-bootstrap';

const PopupErrorMessage = ({
                             isOpen,
                             onHide,
                             errorMessageCode,
                           }) => {
  return (

    <Modal show={isOpen} onHide={onHide}>
      <Modal.Body>
        <div className="h3">
          <FormattedMessage
            id={`userDetails-files-generate-error-${errorMessageCode}-line-1`}
          />
        </div>
        <div className="h4">
          <FormattedMessage
            id={`userDetails-files-generate-error-${errorMessageCode}-line-2`}
          />
        </div>
      </Modal.Body>
      <Modal.Footer className="justify-content-start">
        <Button variant="primary" onClick={onHide}>
          <FormattedMessage
            id="userDetails-files-generate-pdf-close"
            defaultMessage="Close"
          />
        </Button>
      </Modal.Footer>
    </Modal>
  )
};

PopupErrorMessage.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  errorMessageCode: PropTypes.number,
};

export default PopupErrorMessage;
